module.exports = "/images/namecontainer-left.png?071f1348c072b3b3369f3f0f31b28cec";